import { Route, Routes } from 'react-router-dom';
import FilterOverlay from './components/FilterOverlay';
import MapView from './components/MapView';
import SidePanel from './components/SidePanel';
import TopBar from './components/TopBar';
import DashboardsListPage from './pages/DashboardsListPage';
import DashboardEditorPage from './pages/DashboardEditorPage';

function MapShell() {
  return (
    <div className="app-body">
      <div className="map-area" role="region" aria-label="Map">
        <MapView />
        <div className="map-overlay-left">
          <FilterOverlay />
        </div>
      </div>
      <SidePanel />
    </div>
  );
}

function DashboardsListRoute() {
  return (
    <div className="app-body app-body--page">
      <DashboardsListPage />
    </div>
  );
}

function DashboardEditorRoute() {
  return (
    <div className="app-body app-body--page">
      <DashboardEditorPage />
    </div>
  );
}

export default function App() {
  return (
    <div className="app-shell">
      <TopBar />
      <Routes>
        <Route path="/" element={<MapShell />} />
        <Route path="/dashboards" element={<DashboardsListRoute />} />
        <Route path="/dashboards/:id" element={<DashboardEditorRoute />} />
      </Routes>
    </div>
  );
}
